import { dequal } from 'dequal';

function isFalsy(value: unknown): boolean {
  return value === '' || value === null || value === undefined || (Array.isArray(value) && value.length === 0);
}

function cleanFalsyValues<T>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map(cleanFalsyValues).filter((item) => !isFalsy(item)) as unknown as T;
  }

  if (obj && typeof obj === 'object' && !(obj instanceof Date)) {
    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(obj)) {
      const cleaned = cleanFalsyValues(value);
      if (!isFalsy(cleaned)) {
        result[key] = cleaned;
      }
    }
    return result as T;
  }

  return obj;
}

export function deepEqualCleaned<T>(a: T, b: T): boolean {
  const cleanedA = cleanFalsyValues(a);
  const cleanedB = cleanFalsyValues(b);
  return dequal(cleanedA, cleanedB);
}
